import callApi from './callApi';

const editTestStep = async (payload, testStepId) => {
  const url = `teststeps/update/${testStepId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'PUT', body);
}

const getAllTestSteps = async (testCaseId) => {
  const url = `teststeps/${testCaseId}`;
  return await callApi(url, {}, 'GET');
}

const deleteTestStep = async (testStepId) => {
  const url = `teststeps/${testStepId}`;
  return await callApi(url, {}, 'DELETE');
}

const cloneTestSteps = async (payload, testCaseId) => {
  const url = `teststeps/clone/${testCaseId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'PUT', body);
}

const addTestSteps = async (payload, testCaseId) => {
  const url = `teststeps/add/${testCaseId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'PUT', body);
}

const changeStepNumber = async (steps) => {
  const url = `teststeps/rearrange`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    testSteps: [...steps],
  };
  return await callApi(url, headers, 'PUT', body);
}
export { getAllTestSteps, editTestStep, deleteTestStep, cloneTestSteps, changeStepNumber, addTestSteps }